<template>
  <b-icon icon="plus-circle"/>
</template>
<script>
export default {
  name:"AddIcon",
}
</script>
